// export const BASE_URL = "http://localhost:3001/api";
// export const CDN_BASE_URL = "http://localhost:3001/";

export const BASE_URL = "https://api.1924.ir/api";
export const CDN_BASE_URL = "https://api.1924.ir/";
export const PUBLIC_VAPID_KEY =
  "BOpDGrfw-PW0zKvHJ5z2FhrxX3KyZi-lOWbEgCrhPYAPonF8qBvrAbHVT6EkUM_ad0ncMmIpBcS8HdaF-I0fTVk";
export const PRIVATE_VAPID_KEY = "ThMcqBH3VXaJ5aUA-c6Lk45in6B4DqGIhVhoSfM7AbI";
